import { Box, Stack } from '@chakra-ui/react'

import type { FormWizardV2Step } from './types'

export default function FormWizardV2ChecklistHorizontal<T extends string>({
  steps,
  currentStep,
}: {
  steps: FormWizardV2Step<T>[]
  currentStep: FormWizardV2Step<T>
}): JSX.Element {
  const visibleSteps = steps.filter(item => item.disabled !== 'hidden')
  const activeStepIndex = visibleSteps.findIndex(step => step.slug === currentStep.slug)

  return (
    <Box position="sticky">
      <Stack direction="row" spacing="3px">
        {visibleSteps.map((step, index) => (
          <Box
            flex={1}
            bg={index > activeStepIndex ? 'primary.subtle' : 'primary.solid'}
            height="12px"
            width="100%"
            borderLeftRadius={index === 0 ? '8px' : 0}
            borderRightRadius={index === steps.length - 1 ? '8px' : 0}
            key={step.slug}
          />
        ))}
      </Stack>
    </Box>
  )
}
